import { useContext } from "react";

import { LinearInterpolator } from "react-map-gl";

import AddIcon from "@mui/icons-material/Add";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ButtonGroup from "@mui/material/ButtonGroup";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import RemoveIcon from "@mui/icons-material/Remove";

import { ViewStateContext } from "../UrlParser/UrlParser";

import { iconButtonStyle, styles } from "../../config/config.theme";

const ZoomControl = () => {
  const { setViewState } = useContext(ViewStateContext);

  const buttonStyle = {
    ...iconButtonStyle,
    m: 0,
    "&:hover": { backgroundColor: `${styles["background-secondary"]}` },
  };

  const zoomIn = () => {
    setViewState((prevState) => {
      return {
        ...prevState,
        zoom: prevState.zoom + 1,
        transitionDuration: 500,
        transitionInterpolator: new LinearInterpolator(),
      };
    });
  };

  const zoomOut = () => {
    setViewState((prevState) => {
      return {
        ...prevState,
        zoom: prevState.zoom - 1,
        transitionDuration: 500,
        transitionInterpolator: new LinearInterpolator(),
      };
    });
  };

  const resetNorth = () => {
    setViewState((prevState) => {
      return {
        ...prevState,
        pitch: 0,
        bearing: 0,
        transitionDuration: 200,
        transitionInterpolator: new LinearInterpolator(),
      };
    });
  };

  const buttons = [
    <IconButton
      key="zoom in"
      aria-label="zoom in"
      variant="outlined"
      onClick={zoomIn}
      sx={buttonStyle}
    >
      <AddIcon fontSize="1.5rem" color="primary" />
    </IconButton>,
    <IconButton
      key="zoom out"
      aria-label="zoom out"
      variant="outlined"
      onClick={zoomOut}
      sx={{
        ...buttonStyle,
        borderBottom: `solid 1px ${styles["background-quaternary"]}`,
        borderTop: `solid 1px ${styles["background-quaternary"]}`,
      }}
    >
      <RemoveIcon fontSize="1.5rem" color="primary" />
    </IconButton>,
    <IconButton
      key="reset north"
      aria-label="reset north"
      variant="outlined"
      onClick={resetNorth}
      sx={buttonStyle}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <ArrowDropUpIcon
          fontSize="1.5rem"
          color="primary"
          sx={{ mb: "-8px" }}
        />
        <ArrowDropDownIcon fontSize="1.5rem" color="primary" />
      </Box>
    </IconButton>,
  ];

  return (
    <ButtonGroup
      orientation="vertical"
      aria-label="vertical outlined button group"
    >
      {buttons}
    </ButtonGroup>
  );
};

export default ZoomControl;
